import Component from 'antd/es/tag';
import 'antd/lib/tag/style';
export default Component;
